/**
 * Shared styling for the job detail summary bar.
 *
 * The bar's action buttons (Status / Allocate / Part Action) and the tag
 * editor's Save button are the same affordance visually, so they share one
 * definition rather than two copies that drift.
 */
export const accentButtonSx = {
  bgcolor: 'v4.accent',
  py: '5px',
  px: '10px',
  textTransform: 'none' as const,
  fontWeight: 600,
  fontSize: '11px',
  color: 'common.white',
  whiteSpace: 'nowrap',
  '&:hover': { bgcolor: 'v4.accent', opacity: 0.9 },
  // Without this the button loses its fill while the save is in flight and
  // reads as a gap in the popover.
  '&.Mui-disabled': { bgcolor: 'v4.accent', opacity: 0.5, color: 'common.white' },
};
